module.exports = __webpack_public_path__ + "img/bg-footer-home.34317a44.jpg";